export default () => {
	let $video = $('.img-placeholder');

	$video.on ('click', function () {
		const $videoIframe = $(this).closest('.info-media').children('iframe');
		$(this).fadeOut('slow');
		if ($videoIframe.length) {
			$videoIframe[0].src += "&autoplay=1";
		}
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/_play-video.js